import { render } from "./CompletedCheckbox.vue?vue&type=template&id=72ed4bf4"
import script from "./CompletedCheckbox.vue?vue&type=script&lang=js"
export * from "./CompletedCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/ToDo/CompletedCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72ed4bf4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72ed4bf4', __exports__)) {
    console.log('reload')
    api.reload('72ed4bf4', __exports__)
  }
  
  module.hot.accept("./CompletedCheckbox.vue?vue&type=template&id=72ed4bf4", () => {
    console.log('re-render')
    api.rerender('72ed4bf4', render)
  })

}


export default __exports__